/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import DeleteIcon from '@material-ui/icons/Close';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { AppContext } from 'Context';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Chip, TextField, Popper, CircularProgress } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import styles from '../ShareScreenClassic.module.css';
import './newSearchInput.css';
import PersonButton from './PersonButtonClassic';

const StyledPopper = withStyles({
  root: {
    marginTop: '8px !important',
    animation: 'dropdownSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '& .MuiAutocomplete-paper': {
      borderRadius: '8px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
      border: '1px solid #e5e7eb',
      background: 'linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%)',
      overflow: 'hidden',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '15px',
      maxHeight: '320px',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f3f4f6',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#d1d5db',
        borderRadius: '10px',
        '&:hover': {
          background: '#9ca3af',
        }
      }
    },
    '& .MuiAutocomplete-option': {
      padding: '0 !important',
      minHeight: 'auto !important',
      borderRadius: '8px !important',
      marginBottom: '8px !important',
      background: 'linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%) !important',
      '&:last-child': {
        marginBottom: '0 !important',
      }
    },
    '& .MuiAutocomplete-noOptions': {
      padding: '16px',
      textAlign: 'center',
      color: '#6b7280',
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '14px',
    }
  }
})(Popper);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'start',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  tag: {
    'border': 'none',
    'background': '#f3f4f6',
    fontWeight: '500',
    fontFamily: '"Montserrat", sans-serif !important',
    fontSize: '13px',
    padding: '10px',
    height: '28px',
    borderRadius: '30px',
    color: '#000000',
    transition: 'none',
    boxShadow: 'none',
    margin: '3px !important',
    animation: 'chipSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: '#f3f4f6',
      transform: 'none',
      boxShadow: 'none',
    },
    '& svg': {
      color: '#EF4444',
      fontSize: '18px !important',
      transition: 'all 0.2s ease',
      '&:hover': {
        color: '#DC2626',
        transform: 'scale(1.15)',
      }
    },
    '& .MuiChip-label': {
      padding: '0 6px',
      fontWeight: '500',
      fontSize: '13px',
      lineHeight: '1.2',
      color: '#000000',
    }
  },
  option: {
    height: '10px'
  }
}));

const CssTextField = withStyles({
  root: {
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInputBase-input': {
      height: '2.5em',
      padding: '12px 12px',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
      padding: '12px 12px',
    },
    '& .MuiInputBase-root': {
      color: '#1f2937',
      fontFamily: '"Montserrat", sans-serif !important',
      fontSize: '14px',
      fontWeight: '500',
      padding: '3px 3px',

      minHeight: '48px',
      border: '2px solid #e5e7eb',
      borderRadius: '30px',
      background: '#ffffff',
      transition: 'border-color 0.2s ease',
    },
    '& .MuiInputBase-root:hover': {
      borderColor: '#d1d5db',
    },
    '& .MuiInputBase-root.Mui-focused': {
      borderColor: '#5aa5ef',
      boxShadow: '0 0 0 3px rgba(90, 165, 239, 0.1)',
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#9ca3af',
      opacity: 1,
      fontSize: '14px',
    }
  },
})(TextField);

export default function SearchInput({
  handlingAction, searchInputHandler, setUserSearchingStatus, cancelToken, setEmailToSearch, setUserList,
  setCancelToken, AxiosCancelToken, inputPlaceholder, selectedUsers, removeUser, searchUsers, userList, selectUser,
  removeUserFromList, selectUserFromList, emailToSearch, onEnterPress, duplicateErrorType, isSelfSelected, isDisabled,
  searchingUsers
}) {
  const classes = useStyles();
  const { langText } = useContext(AppContext);
  const commonText = langText?.common;
  const [oldLength, newLength] = useState(0);

  // Filter out already selected users and ensure userList is an array
  // Don't show any suggestions while API is loading to prevent showing stale/typed email
  const uniqueUserList = searchingUsers ? [] : (Array.isArray(userList) ? userList : []).filter(
    (user) => !selectedUsers.some((selectedUser) => selectedUser.email === user.email)
  );

  const [inputValue, setInputValue] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  // Filter options based on input value
  const filteredOptions = React.useMemo(() => {
    if (!inputValue || inputValue.trim().length === 0) {
      return [];
    }
    return uniqueUserList.filter((option) => option.email?.toLowerCase().includes(inputValue.toLowerCase())
      || option.firstname?.toLowerCase().includes(inputValue.toLowerCase())
      || option.lastname?.toLowerCase().includes(inputValue.toLowerCase()));
  }, [inputValue, uniqueUserList]);

  const showHelperText = !inputValue || inputValue.length === 0;

  // Control dropdown visibility based on whether there are filtered options
  React.useEffect(() => {
    setOpen(filteredOptions.length > 0 && inputValue.length > 0);
  }, [filteredOptions.length, inputValue]);

  // Control loading state - only stop when search is complete
  React.useEffect(() => {
    // Stop loading when search is complete (searchingUsers becomes false)
    if (!searchingUsers) {
      setLoading(false);
    }
  }, [searchingUsers]);

  return (
    <div className={styles.shareScreenEmailInput}>
      {isSelfSelected ? (
        <div className={styles.errorText}>
          You can&apos;t invite yourself to a group
        </div>
      ) : duplicateErrorType === 'member' ? (
        <div className={styles.errorText}>
          This user is already a member of the group.
        </div>
      ) : duplicateErrorType === 'pending' ? (
        <div className={styles.errorText}>
          This user has already been invited.
        </div>
      ) : null}
      {showHelperText && (
        <div className={styles.helperText}>
          {commonText?.startTypingMsg || 'Start typing email to search'}
        </div>
      )}
      <Autocomplete
        multiple
        id="tags-standard"
        disableClearable
        forcePopupIcon={false}
        filterSelectedOptions
        autoHighlight
        open={open}
        onOpen={() => {
          if (filteredOptions.length > 0) {
            setOpen(true);
          }
        }}
        onClose={() => setOpen(false)}
        filterOptions={(options) => options}
        PopperComponent={StyledPopper}
        classes={{
          tag: classes.tag,
          option: styles.option
        }}
        noOptionsText=""
        options={filteredOptions}
        value={selectedUsers}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          // Show loader when user starts typing
          if (newInputValue && newInputValue.trim().length > 0) {
            setLoading(true);
          } else {
            setLoading(false);
          }
        }}
        onChange={(event, newValue) => {
          // Handle selection via Enter key or click
          if (newValue.length > selectedUsers.length) {
            const addedUser = newValue[newValue.length - 1];
            selectUserFromList(addedUser);
            // Clear the suggestion list after selection
            setUserList([]);
            setEmailToSearch('');
          }
        }}
        renderOption={(option) => ((
          <PersonButton
            data={option}
            key={option?.id}
            onClick={() => {
              selectUserFromList(option);
              // Clear the suggestion list after selection
              setUserList([]);
              setEmailToSearch('');
            }}
          />
        ))}
        renderTags={(values, getTagProps) => {
          const uniqueValues = values.filter((value, index, self) => index === self.findIndex((v) => v.id === value.id));
          return uniqueValues.map((option, index) => (
            <Chip
              variant="outlined"
              label={option?.email}
              {...getTagProps({ index })}
              deleteIcon={(
                <div aria-hidden="true">
                  <RemoveCircleIcon
                    onClick={(event) => {
                      removeUserFromList(option);
                    }}
                    className="MuiChip-deleteIcon"
                    style={{ margin: '0px 5px 0px 4px', color: '#EF4444' }}
                  />
                </div>
              )}
            />
          ));
        }}
        getOptionLabel={(option) => option?.email}
        renderInput={(params) => (
          <CssTextField
            disableUnderline
            {...params}
            autoComplete="off"
            variant="standard"
            placeholder={selectedUsers?.length === 0 ? inputPlaceholder : ''}
            autoFocus
            onChange={(e) => {
              searchUsers(e);
            }}
            onFocus={(e) => {
              // Clear the user list when input is focused and there's no search text
              if (!e.target.value || e.target.value.trim() === '') {
                setUserList([]);
                setEmailToSearch('');
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // Check if user is selecting from dropdown (default autocomplete behavior)
                const dropdownElement = document.querySelector('.MuiAutocomplete-popper');
                const isDropdownVisible = dropdownElement && dropdownElement.style.display !== 'none';
                const hasOptions = uniqueUserList && uniqueUserList.length > 0;

                // Check if form submission is disabled
                const isFormDisabled = isDisabled || handlingAction || duplicateErrorType !== null || isSelfSelected || selectedUsers?.length <= 0;

                // Only trigger form submission if:
                // 1. Not selecting from dropdown OR
                // 2. Dropdown is not visible OR
                // 3. No options available in dropdown
                // 4. Form is not disabled
                if ((!isDropdownVisible || !hasOptions) && onEnterPress && !isFormDisabled) {
                  e.preventDefault();
                  onEnterPress();
                }
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '12px'
                      }}
                    >
                      <div className={styles.spinnerLoader} />
                    </div>
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  );
}
